import { ComputedStaticTextInput } from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IComputedStringWidget } from '../IComputedWidget.ts';

export type IComputedStringWidgetComponentProps =
  IWidgetComponentProps<IComputedStringWidget>;

export function ComputedStringWidgetComponent(
  props: IComputedStringWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options?.helpText ? (
          <RichTextAdvancedRender inline text={options?.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <ComputedStaticTextInput
        name={options.name}
        removeBorder={widget.layout?.removeBorder}
      />
    </ConfigFormItem>
  );
}
